import {mapGraphParameters} from "#graph/helpers/parameters"
import {BaseGraphNode} from "#graph/nodes/base/base-graph-node"
import type {SerializedGraphNode} from "#graph/serialization/types"

export const serializeGraphNode = (node: BaseGraphNode, refCache: Map<BaseGraphNode, number> = new Map<BaseGraphNode, number>()): SerializedGraphNode => {
    const cachedRefId = refCache.get(node)
    if (cachedRefId !== undefined)
        return {
            $class: "GraphRef",
            $parameters: {},
            $refId: cachedRefId,
            $version: 0,
        }

    const refId = refCache.size
    refCache.set(node, refId)

    return {
        $class: node.nodeClass,
        $parameters: mapGraphParameters<BaseGraphNode, SerializedGraphNode>(
            node.parameters,
            (value) => value instanceof BaseGraphNode,
            (child) => {
                return serializeGraphNode(child, refCache)
            },
        ),
        $refId: refId,
        $version: node.nodeVersion,
    }
}
